/* eslint-disable consistent-return */
/* eslint-disable func-names */
/* eslint-disable react/no-this-in-sfc */
import React, { useState, useRef } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';

import CardDocument from '@components/CardDocument';

import './style.scss';

const FileInput = ({ txtBtnUpload, txtDrop, onChangeFile, files, removeAllFiles, removeFile, maxFileSize, accept, widthImg, heightImg, maxFiles, classNameBorderMain }) => {
  const [isDragOver, setIsDragOver] = useState(false);
  const [isDetailed, setisDetailed] = useState({ visible: false });

  const inputFile = useRef(null);
  const toastErroSize = useRef(null);

  const handleDragOver = (e) => {
    if ('preventDefault' in e) {
      e.stopPropagation();
      e.preventDefault();
    }
    if (e.type === 'dragover') setIsDragOver(true);
    else setIsDragOver(false);
  };

  const handleFileSelect = (e) => {
    e.preventDefault();
    handleDragOver(e);
    let isError = false
    let isImage = false
    const _files = e.target.files || e.dataTransfer.files
    const [ file ] = _files
    if (maxFiles && files.length === maxFiles) return toastErroSize.current.show({severity:'error', summary: 'Maximo de archivos superado', detail: `El maximo de archivos permitidos es: ${maxFiles}`, life: 3000});
    if (maxFileSize) {
      if (file.size > maxFileSize) {
        isError = true
        toastErroSize.current.show({severity:'error', summary: 'Error al cagar archivo', detail:'Tamaño de archivo excede el máximo', life: 3000});
      }
    }
    if (widthImg || heightImg) {
      // eslint-disable-next-line no-undef
      const img = new Image();
      img.src = URL.createObjectURL(file);
      img.onload = function() {
        isImage = true
        if (widthImg && heightImg) {
          if ( this.width !== widthImg && this.height !== heightImg ) {
            isError = true
            toastErroSize.current.show({severity:'error', summary: 'Error al cagar imagen', detail:`Las medidas deben ser: ${widthImg} x ${heightImg}`, life: 3000});
          }
        } else if (widthImg) {
          if ( this.width !== widthImg ) {
            isError = true
            toastErroSize.current.show({severity:'error', summary: 'Error al cagar imagen', detail:`El ancho de la imagen deber ser: ${widthImg}`, life: 3000});
          }
        } else if (heightImg) {
          if ( this.height !== heightImg ) {
            isError = true
            toastErroSize.current.show({severity:'error', summary: 'Error al cagar imagen', detail:`La altura de la imagen deber ser: ${widthImg}`, life: 3000});
          }
        }
        return true
      }
    }
    setTimeout(() => {
      if (!isError) return onChangeFile(_files, isImage);
      return true
    }, 100)
  };



  const showPreview = (doc) => {
    setisDetailed({
      visible: true,
      ...doc,
    });
  };
  const closePreview = () => {
    setisDetailed({
      visible: false,
    });
  };

  const content = () => (
    <div className="p-grid">
      {files.map((doc) => (
        <div key={doc.fileName} className="p-col-12 p-md-6 p-lg-4 p-d-flex p-jc-center p-jc-sm-start">
          <CardDocument
            file={doc.file}
            removeFile={() => removeFile(doc)}
            preview={() => showPreview(doc)}
          />
        </div>
      ))}
    </div>
  );

  const previewFile = () => {
    if (isDetailed.fileExtension === 'pdf') {
      return (
        <iframe
          src={isDetailed.currentValue}
          className="modal-component-iframe"
          title={isDetailed.name}
        />
      );
    }
    return (
      <div className="p-text-center">
        <img
          src={isDetailed.currentValue}
          className="modal-component-image"
          alt={isDetailed.name}
        />
      </div>
    );
  };

  const configDragClassName = classNames('base-file p-d-flex p-jc-center p-ai-center', { hover: isDragOver });
  const configFileContentClassName = classNames(
    'base-file-content',
    files.length
      ? 'is-full-width is-full-height'
      : ''
  );

  return (
    <div className="card p-fluid p-mb-0 p-p-0">
      <div className={`upper-border ${classNameBorderMain}`}>
        <div className="p-d-flex p-jc-end">
          <i
            className="pi pi-times"
            onClick={removeAllFiles}
            aria-hidden="true"
            style={{fontSize: '1.2rem', fontWeight: 'bold'}}
          />
        </div>
        <div
          className={configDragClassName}
          draggable="true"
          onDragOver={handleDragOver}
          onDragLeave={handleDragOver}
          onDrop={handleFileSelect}
        >
          <div className={configFileContentClassName}>
            {files.length ? (
              content()
            ) : (
              <span
                style={{ fontSize: '1.4em', color: 'var(--text-color-secondary)' }}
                className="p-my-5"
              >
               {txtDrop}
              </span>
            )}
            <input
              type="file"
              id="file"
              name="file"
              ref={inputFile}
              style={{ display: 'none' }}
              onChange={handleFileSelect}
              accept={accept}
            />
          </div>
        </div>
      </div>
      <div className="p-d-flex p-jc-center">
        <Button
          type="button"
          label={txtBtnUpload}
          className="p-button p-mt-3"
          onClick={() => inputFile.current && inputFile.current.click()}
        />
      </div>
      { isDetailed.visible && (
        <Dialog
          header="Detalle"
          visible={isDetailed.visible}
          breakpoints={{'960px': '75vw'}}
          style={{ width: '70vw' }}
          onHide={closePreview}
          maximizable
          modal
        >
          {previewFile()}
        </Dialog>
      )}
      <Toast ref={toastErroSize} />
    </div>
  );
};

FileInput.defaultProps = {
  txtBtnUpload: 'Cargar',
  txtDrop: 'Arrastrar y suelta archivos'
};
FileInput.prototype = {
  txtBtnUpload: PropTypes.string,
  txtDrop: PropTypes.string,
  onChangeFile: PropTypes.func,
  files: PropTypes.any,
  removeAllFiles: PropTypes.func,
  removeFile: PropTypes.func,
  maxFileSize: PropTypes.number,
  accept: PropTypes.string,
  widthImg: PropTypes.string,
  heightImg: PropTypes.string,
  maxFiles: PropTypes.number,
  classNameBorderMain: PropTypes.string,
};

export default FileInput;
